import { useCallback, useMemo } from 'react'

import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { IPlanChangeLog } from 'partner360/models/planning/IPlanChangeLog'

import styles from './LogsPaging.module.scss'

interface ILogsPagingProps {
  selectedGroupIndex: number
  changeGroupIndex: (index: number) => void
  groups: Record<string, IPlanChangeLog[]>
  subCategory: string
}

export const LogsPaging = ({
  selectedGroupIndex,
  changeGroupIndex,
  groups,
  subCategory,
}: ILogsPagingProps) => {
  const allGroupsCount = useMemo(() => {
    return Object.keys(groups).length
  }, [groups])

  const { canMoveLeft, canMoveRight } = useMemo(() => {
    const keys = Object.keys(groups)
    const lastIndex = keys.length - 1

    return {
      canMoveLeft: selectedGroupIndex > 0,
      canMoveRight: selectedGroupIndex < lastIndex,
    }
  }, [selectedGroupIndex, groups])

  const onClickRight = useCallback(() => {
    changeGroupIndex(selectedGroupIndex + 1)
  }, [changeGroupIndex, selectedGroupIndex])

  const onClickLeft = useCallback(() => {
    changeGroupIndex(selectedGroupIndex - 1)
  }, [changeGroupIndex, selectedGroupIndex])

  if (Object.keys(groups).length <= 1) {
    return null
  }

  return (
    <Flex gap={'none'} className={styles.root} alignItems={'center'}>
      <Button
        variant={'text'}
        iconButton={'kbase kbase-omni-chevron-left'}
        disabled={!canMoveLeft}
        onClick={onClickLeft}
      />
      <span>{`${selectedGroupIndex + 1}/${allGroupsCount}`}</span>
      <Button
        variant={'text'}
        iconButton={'kbase kbase-omni-chevron-right'}
        disabled={!canMoveRight}
        onClick={onClickRight}
      />
      <strong>{subCategory}</strong>
    </Flex>
  )
}
